module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-wrap",
    on: {
      "click": _vm.onImgClick
    }
  }, [(!_vm.onlyImage) ? _c('div', {
    staticClass: "img verticalM"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imgPath),
      expression: "imgPath"
    }],
    staticClass: "verticalM-box",
    class: {
      floatL: _vm.isLeftRight
    },
    style: (_vm.imgStyle)
  })]) : _vm._e(), _vm._v(" "), (!_vm.onlyImage) ? _c('div', {
    staticClass: "detail",
    class: {
      floatL: _vm.isLeftRight
    }
  }, [(_vm.titleText) ? _c('div', {
    staticClass: "title ellipsis",
    attrs: {
      "title": _vm.titleText == true ? '' : _vm.titleText
    }
  }, [_vm._t("title", function() {
    return [_vm._v(_vm._s(_vm.titleText))]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.moneyText) ? _c('div', {
    staticClass: "money"
  }, [_c('span', {
    staticClass: "nowCost ellipsis",
    class: {
      width: _vm.orginalCost > 0
    }
  }, [(_vm.moneyText > 0) ? _c('samp', [_vm._v("¥")]) : _vm._e(), _vm._v(" "), _vm._t("money", function() {
    return [_vm._v(_vm._s(_vm.moneyText))]
  })], 2), _vm._v(" "), (_vm.orginalCost && _vm.orginalCost > 0) ? _c('span', {
    staticClass: "orginalCost"
  }, [_c('samp', [_vm._v("¥")]), _vm._v(" "), _c('samp', [_vm._t("orginalCost", function() {
    return [_vm._v(_vm._s(_vm.orginalCost))]
  })], 2)]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.onlyImage) ? _c('div', {
    class: {
      clearfix: _vm.isLeftRight
    }
  }) : _vm._e(), _vm._v(" "), (_vm.onlyImage) ? _vm._t("image", function() {
    return [_c('img', {
      style: (_vm.imgStyle),
      attrs: {
        "src": _vm.imagePath
      }
    })]
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57bacff4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/image/image.vue
// module id = 404
// module chunks = 68